import mixpanel from 'mixpanel-browser';

import { BuildADashTrackingEvents } from '@revelio/core';

export type AIAssistantSurface = 'global' | 'dashboard' | 'report';

export type AIAssistantPromptMode =
  | 'generate'
  | 'update'
  | 'clarification_answer';

type TrackAIAssistantPromptArgs = {
  assistantSurface: AIAssistantSurface;
  conversationId: string;
  turnIndex: number;
  promptText: string;
  promptMode: AIAssistantPromptMode;
  entityType?: string;
};

export function trackAIAssistantPrompt({
  assistantSurface,
  conversationId,
  turnIndex,
  promptText,
  promptMode,
  entityType,
}: TrackAIAssistantPromptArgs): void {
  mixpanel.track(BuildADashTrackingEvents.AI_ASSISTANT_PROMPT_SUBMIT, {
    assistant_surface: assistantSurface,
    conversation_id: conversationId,
    turn_index: turnIndex,
    prompt_text: promptText,
    prompt_length: promptText.length,
    prompt_mode: promptMode,
    ...(entityType ? { entity_type: entityType } : {}),
  });
}
